import '../../css/base.css';

const Heating = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Heating</h2>
      <p className="your-stay-text">Heating downstairs is via 3 storage heaters. They heat up in the middle
                                    of the night and let the heat out during the day. There are two controls
                                    ‘Input’ and ‘Output’. The input setting is set for how much heat is taken
                                    in during the night. The higher the input setting the greater the amount of heat
                                    stored. Output should be set at 1 overnight so that the heat is maintained
                                    in the heater. If you want to increase it the next day then set up to 9 to get
                                    more heat out. But when the heat is gone it is gone, so we normally set it
                                    to 3 or 4 to give a constant heat throughout the day
      </p>                                            
      <p className="your-stay-text">Electric heaters upstairs are on demand so turn them on whenever you
                                    need them. There are also 2 movable electric heaters, which you can
                                    position wherever you need them in the house. They heat up very
                                    quickly. <strong>Please do not dry clothes on the storage heaters</strong>.
      </p>
    </div>
  );
}

export default Heating;